import React, { useState } from "react"
import { useSelector } from "react-redux"
import { selectAuthState } from "@/store/features/authSlice"
import arrowLeft from "@/public/icons/back-arrow.svg"
import info from "@/public/icons/info.svg"
import CartServiceIcon from "@/public/icons/install-service-cart-icon.svg"
import styles from "./returnConfirmation.module.scss"
import ReturnListItem from "@/components/Returns/v1/ReturnListItem/ReturnListItem"
import { getTranslations } from "@/components/Returns/v1/localization"
import { useTranslation } from "next-i18next"
import Image from "next/image"
import { NumericFormat } from "react-number-format"

const ReturnConfirmation = ({
  skuId = "",
  faulyData = [],
  returnedItems = {},
  data = {},
  currencySign = "",
  brandName = "",
  isReturns = false,
  curstep = 1,
  quantityVal = 1,
  reasonList = [],
  getItems = () => {},
  handleReturnData = () => {},
  orderNumber = "",
  orderDetailsUrl = "/",
  isSuccess = false,
  orderSummary={},
}) => {
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const {
    user: { sub: userEmail, firstName = "", lastName = "", login = "" } = {},
  } = useSelector(selectAuthState)

  const shipItem = data?.item?.find(item => item.sku === skuId) ?? {}
  const isBundleAssociated = shipItem?.udf6 !== "" ? orderSummary?.shipments?.filter(list => list?.extOrderNo === `${orderNumber}-SRV`)[0]?.shipDetail[0]?.item?.filter(service => service.udf6 === shipItem?.udf6)[0]?.canReturn === "true" : false
  const isServiceReturned = orderSummary?.shipments?.filter(list => list?.extOrderNo === `${orderNumber}-SRV`)[0]?.shipDetail[0]?.item?.filter(list => list.sku === shipItem.udf1)[0]?.canReturn === "true" ? true : false
  
  const handleOrderRedirect = () => {
    const redirectionLink = `${orderDetailsUrl}?orderNumber=${orderNumber}&sku=${shipItem?.udf1}`
    window.location.href = redirectionLink
  }

  const handleRefund = () => {
    let price = ""
    const getPrice = shipItem?.price * returnedItems?.quantity
    const discount =
      (shipItem?.discAmount / quantityVal) * returnedItems?.quantity
    price = getPrice - discount
    return Number(price)?.toFixed(2)
  }

  return (
    <>
      <div className={styles.thankyouHeader}>
        <div className="container kf-react-container">
          <div className="thankyou__back">
            <img src={arrowLeft?.src} alt="Back" />
            <p onClick={handleOrderRedirect}>{staticText.backToOrder}</p>
          </div>
          <div className="thankyou-header__flex">
            <div className="thankyou-header__flex--detail">
              <h3>{staticText.returnConfirmTitle}</h3>
              <p>{staticText.returnConfirmPara}</p>
              <p>{staticText.returnConfirmDay}</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.thankyouReturnitems}>
        <div className="container kf-react-container thankyou-returnitems--summary">
          <h2>{staticText.returnConfirmItem}</h2>
          <div className="return-confirm-tile">
            <ReturnListItem
              isReturns={isSuccess}
              curstep={curstep}
              data={data ?? {}}
              brandName={brandName}
              currencySign={currencySign}
              staticText={staticText}
              quantityVal={quantityVal}
              returnList={reasonList}
              getItems={getItems}
              handleReturnData={handleReturnData}
              skuId={skuId}
              returnData={
                returnedItems?.returnData !== ""
                  ? returnedItems?.returnData
                  : staticText.noReason
              }
              totalQuantity={quantityVal}
              isReturnConfirmed={true}
              returnedItems={returnedItems}
            />
          </div>
          <div className="return-confirm-refund">
            <p>{staticText.refundAmount}</p>
            <p>
              <NumericFormat
                value={handleRefund()}
                displayType={"text"}
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
                thousandsGroupStyle={"lakh"}
                allowNegative={false}
              />
            </p>
          </div>
          {faulyData?.length ? (
            <div className="return-confirm-faulty thankyou-contactinfo">
              <h3>{staticText.faulty}</h3>
              <p>{faulyData?.length + " " + staticText.imageUpload}</p>
            </div>
          ) : null}
          {firstName ? (
            <div className="thankyou-contactinfo">
              <h3>{staticText.requestContact}</h3>
              <p>{firstName + " " + lastName}</p>
              <p>{login}</p>
              <p>{userEmail}</p>
            </div>
          ) : null}

          {isServiceReturned || isBundleAssociated && shipItem.udf2 !== "NA for service" ? (
            <div className="return-confirm-related">
              <h3>{staticText.related}</h3>
              <div className="return-confirm-eligible">
                <Image src={info} alt="" />
                <div className="return-confirm-info">
                  <p>{staticText.eligible}</p>
                  <span>{staticText.following}</span>
                </div>
              </div>
              <div className="return-confirm-installation">
                <div className="return-confirm-sku">
                  <Image src={CartServiceIcon} alt="" />
                  <p>{staticText.installationService(shipItem?.udf6 !== "" ? shipItem?.udf6 : shipItem?.udf1)}</p>
                </div>
                <div className="return-confirm-price">
                  <button
                    role="button"
                    tabIndex="0"
                    className="return__service-button"
                    onClick={handleOrderRedirect}
                  >
                    <Image src={info} alt="" /> {staticText.service}
                  </button>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  )
}

export default ReturnConfirmation
